import React from 'react'

const Profile = () => {
    return (
        <h1>
            profile
        </h1>
    )
}

export default Profile
